<template>
    <div>
        <div class="planning">
            <calendar-component
                :expose="expose"
            ></calendar-component>
        </div>
        <template v-if="!expose">
            <planning-date-details-component></planning-date-details-component>
            <planning-form-component></planning-form-component>
            <individual-planning-component></individual-planning-component>
            <slot-hover-info-component></slot-hover-info-component>
            <day-hover-info-component></day-hover-info-component>
            <context-menu-component></context-menu-component>
            <message-modal-component></message-modal-component>
        </template>
    </div>
</template>

<script>
import CalendarComponent from './CalendarComponent.vue';
import PlanningFormComponent from './PlanningFormComponent';
import SlotHoverInfoComponent from './info-components/SlotHoverInfoComponent';
import DayHoverInfoComponent from './info-components/DayHoverInfoComponent';
import ContextMenuComponent from './info-components/ContextMenuComponent.vue';
import MessageModalComponent from '../helpers/MessageModalComponent.vue';
import PlanningDateDetailsComponent from './info-components/PlanningDateDetailsComponent';
import IndividualPlanningComponent from './PlanningIndividualPlanningComponent.vue';
export default {
    components: {
        PlanningDateDetailsComponent,
        CalendarComponent,
        PlanningFormComponent,
        IndividualPlanningComponent,
        SlotHoverInfoComponent,
        DayHoverInfoComponent,
        ContextMenuComponent,
        MessageModalComponent,
    },
    props: {
        expose: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
};
</script>
